import { FilterType, ColourFilter } from '../types'

export const isColourFilter = (filter: FilterType): filter is ColourFilter =>
  filter.type === 'colour'
